<template>
	<Modal style="background-color: white; top: 30px; width: 100%; padding: 0 50px">
		<div class="instruction">
			<div class="heading">
				<i
					class="fas fa-angle-left"
					@click="$emit('previous')"
				/>
				<h1>{{ $t('antesDeComecarmos') }}</h1>
			</div>
			<div>
				<p>
					{{ $t('verifiqueAsColunas') }}
				</p>
				<a @click="downloadExemplo">{{ $t('baixeArquivoModelo') }}</a>
			</div>
			<h1 class="title">Dados cadastrais</h1>
			<table cellspacing="0">
				<thead>
					<tr>
						<th
							v-for="(coluna, index) in colunasCadastrais"
							:key="coluna.nome + index"
						>
							{{ coluna.nome }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td
							v-for="(coluna, index) in colunasCadastrais"
							:key="coluna.exemplo + index"
						>
							{{ coluna.exemplo }}
						</td>
					</tr>
				</tbody>
			</table>
			<div class="instruction-container">
				<p
					v-for="coluna in colunasCadastrais"
					:key="coluna.key"
					style="padding: 0.15rem 0"
				>
					{{ $t('column') }}
					<strong>{{ `${coluna.nome} ${coluna.unidade || ''}` }}</strong>
					{{ coluna.descricao.replace('Coluna', '') }}
					{{ $t('emFormato') }}
					<strong>{{ coluna.formato === 'number' ? 'Número' : 'Texto' }}</strong>
				</p>
			</div>

			<h1 class="title">Dados de coleta</h1>
			<div class="w-full">
				<table
					class="w-full"
					cellspacing="0"
				>
					<thead>
						<tr>
							<th
								v-for="(coluna, index) in colunasColeta"
								:key="coluna.nome + index"
							>
								{{ coluna.nome }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td
								v-for="(coluna, index) in colunasColeta"
								:key="coluna.exemplo + index"
							>
								{{ coluna.exemplo }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="instruction-container">
				<p
					v-for="coluna in colunasColeta"
					:key="coluna.key"
					style="padding: 0.15rem 0"
				>
					{{ $t('column') }}
					<strong>{{ `${coluna.nome} ${coluna.unidade || ''}` }}</strong>
					{{ coluna.descricao.replace('Coluna', '') }}
					{{ $t('emFormato') }}
					<strong>{{ coluna.formato === 'number' ? 'Número' : 'Texto' }}</strong>
				</p>
			</div>

			<h1 class="title">Dados de mato competição</h1>
			<table cellspacing="0">
				<thead>
					<tr>
						<th
							v-for="(coluna, index) in colunasMatoCompeticao"
							:key="coluna.nome + index"
						>
							{{ coluna.nome }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td
							v-for="(coluna, index) in colunasMatoCompeticao"
							:key="coluna.exemplo + index"
						>
							{{ coluna.exemplo }}
						</td>
					</tr>
				</tbody>
			</table>
			<div class="instruction-container">
				<p
					v-for="coluna in colunasMatoCompeticao"
					:key="coluna.key"
					style="padding: 0.15rem 0"
				>
					{{ $t('column') }}
					<strong>{{ `${coluna.nome} ${coluna.unidade || ''}` }}</strong>
					{{ coluna.descricao.replace('Coluna', '') }}
					{{ $t('emFormato') }}
					<strong>{{ coluna.formato === 'number' ? 'Número' : 'Texto' }}</strong>
				</p>
			</div>

			<div class="flex 2-full justify-between items-center">
				<Checkbox
					v-model="conscent"
					:label="$t('naoMostrarNovamente')"
				/>
				<Button
					:label="$t('continue')"
					style="width: fit-content; float: right"
					@click="$emit('continue')"
				/>
			</div>
		</div>
	</Modal>
</template>

<script setup>
import { useLocalStorage } from '@vueuse/core'
import { toRefs } from 'vue'
import Button from '../Button/Button.vue'
import Checkbox from '../Checkbox/Checkbox.vue'
import Modal from '../Modal/Modal.vue'

import download from 'downloadjs'

const props = defineProps({
	colunasCadastrais: {
		type: Array,
		defualt: () => [],
	},
	colunasColeta: {
		type: Array,
		defualt: () => [],
	},
	colunasMatoCompeticao: {
		type: Array,
		defualt: () => [],
	},
	chave: { type: String, default: 'default' },
})

const { chave } = toRefs(props)

const conscent = useLocalStorage(`conscent-${chave.value}`, false)

const downloadExemplo = () => {
	const colunas = [
		...props.colunasCadastrais,
		...props.colunasColeta,
		...props.colunasMatoCompeticao,
	]

	const items = Array(5).fill(colunas.map((m) => m.exemplo))

	const header = colunas.map((m) => m.nome.normalize('NFD').replace(/[^a-zA-Z\s]/g, ''))
	const csv = [
		header, // header row first
		...items,
	]
		.map((m) => m.join(';'))
		.join('\r\n')

	download(csv, 'Exemplo Medição.csv', 'text/csv')
}
</script>

<style scoped>
h1 {
	color: var(--neutras-preto, #0c0b0b);
	font-family: 'Open Sans';
	font-size: 22px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}
h1.title {
	color: var(--secondary-secondary-shade-1, #012e4b);

	/* text-H5 */
	font-family: 'Open Sans';
	font-size: 24px;
	font-style: normal;
	font-weight: 700;
	line-height: 28px;
	/* 116.667% */
	letter-spacing: -1px;
}

table {
	white-space: nowrap;
}

.instruction-container {
	background-color: #f1f1f1;
	padding: 1rem;
	border: 1.5px solid #737576;
	border-radius: 5px;
}

.heading {
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
	align-items: center;
}

thead tr {
	background-color: #ccd7df;
}

th {
	color: #01395e;
	text-align: start;
}

th,
td {
	padding: 0 0.5rem;
}

td {
	color: #272728;
	font-size: 0.9rem;
}

i {
	font-size: 1.3rem;
	cursor: pointer;
}

h1,
a,
p {
	margin: 0;
}

.instruction {
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	overflow-y: auto;
	max-height: 80vh;
	width: 100%;
}
</style>
